// AWS Cognito configuration
// This file contains the AWS Cognito configuration for authentication
export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN,
          scopes: ["openid", "email", "phone", "profile", "aws.cognito.signin.user.admin"],
          redirectSignIn: ["https://masav.surpass.co.il/", "http://localhost:3000/"],
          redirectSignOut: ["https://masav.surpass.co.il/", "http://localhost:3000/"],
          responseType: "code",
        },
      },
    },
  },
};
